import { cleanEnv, bool } from 'envalid';
import type { AvailableFeatures } from 'constants/availableFeatures';

type FeatureToggles = Record<AvailableFeatures, boolean>;

export const featureEnvironmentVariables = cleanEnv(process.env, {
  REACT_APP_BLACKOUT_SCREEN: bool({ default: false }),
  REACT_APP_DISABLE_BLACKOUT_SCREEN: bool({ default: false }),
  REACT_APP_ALLOW_SALE_OFFERS: bool({ default: false }),
  REACT_APP_ALLOW_WIN_A_SLICE: bool({ default: false }),
  REACT_APP_ALLOW_SPIN_TO_WIN: bool({ default: false }),
  REACT_APP_WELCOME_BONUS_NOTIFICATION: bool({ default: false }),
  REACT_APP_DISCOUNT_OFFER_ON_SIGN_UP: bool({ default: false }),
  REACT_APP_PERCENT_OFF_FOOD_VOUCHER_NOTIFICATION: bool({ default: false }),
  REACT_APP_ALLOW_JET2HOLIDAYS: bool({ default: false }),
  REACT_APP_AMOUNT_OFF_FOOD_VOUCHER_NOTIFICATION: bool({ default: false }),
  REACT_APP_OFFER_IN_WALLET_NOTIFICATION: bool({ default: false }),
});

export const featureToggles: FeatureToggles = {
  blackoutScreen: featureEnvironmentVariables.REACT_APP_BLACKOUT_SCREEN,
  disableBlackoutScreen: featureEnvironmentVariables.REACT_APP_DISABLE_BLACKOUT_SCREEN,
  allowSaleOffers: featureEnvironmentVariables.REACT_APP_ALLOW_SALE_OFFERS,
  allowWinASlice: featureEnvironmentVariables.REACT_APP_ALLOW_WIN_A_SLICE,
  allowSpinToWin: featureEnvironmentVariables.REACT_APP_ALLOW_SPIN_TO_WIN,
  welcomeBonusNotification: featureEnvironmentVariables.REACT_APP_WELCOME_BONUS_NOTIFICATION,
  discountOfferOnSignUp: featureEnvironmentVariables.REACT_APP_DISCOUNT_OFFER_ON_SIGN_UP,
  percentOffFoodVoucherNotification:
    featureEnvironmentVariables.REACT_APP_PERCENT_OFF_FOOD_VOUCHER_NOTIFICATION,
  allowJet2holidays: featureEnvironmentVariables.REACT_APP_ALLOW_JET2HOLIDAYS,
  amountOffFoodVoucherNotification:
    featureEnvironmentVariables.REACT_APP_AMOUNT_OFF_FOOD_VOUCHER_NOTIFICATION,
  allowOfferInWalletNotification:
    featureEnvironmentVariables.REACT_APP_OFFER_IN_WALLET_NOTIFICATION,
};
